import { z } from "zod"

export const GetBiMetricsSchema = z.object({
  companyId: z.string().transform(BigInt).optional(),
  from: z.string(),
  to: z.string(),
})

export const RegenerateMetricsForDaySchema = z.object({
  date: z.string(),
})
